const isRunningAsApp = () =>
  window.matchMedia('(display-mode: standalone)').matches ||
  window.navigator.standalone === true;

export const setLoginSource = () => {
  localStorage.setItem('loginSource', isRunningAsApp() ? 'app' : 'web');
};

export const handleBackNavigation = (navigate) => {
  const source = localStorage.getItem('loginSource') || 'web';
  if (source === 'web') {
    navigate('/welcome', { replace: true });
  } else {
    navigate('/role-selection', { replace: true });
  }
};

export const handleSignOutNavigation = (navigate) => {
  const source = localStorage.getItem('loginSource') || 'web';
  localStorage.removeItem('loginSource');
  localStorage.removeItem('navoq_remember_me');
  if (source === 'web') {
    navigate('/welcome', { replace: true });
  } else {
    navigate('/role-selection', { replace: true });
  }
};
